export default __webpack_public_path__ + "static/media/champagne.bdfb7cca.jpg";